import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { ParkingSpaceAddressDto } from '../../../api/gen';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-address-item',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule
  ],
  templateUrl: './address-item.component.html',
  styleUrls: ['./address-item.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AddressItemComponent),
      multi: true
    }
  ]
})
export class AddressItemComponent implements ControlValueAccessor {
  form: FormGroup;
  private onChange: (value: ParkingSpaceAddressDto) => void = () => { };
  private onTouched: () => void = () => { };
  private sub: Subscription | undefined;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      firstAddressLine: ['', Validators.required],
      secondAddressLine: [''],
      locality: ['', Validators.required],
      postCode: ['', Validators.required],
      region: [''],
      countryCode: ['', Validators.required],
      latitude: [null],
      longitude: [null]
    });
  }

  writeValue(value: ParkingSpaceAddressDto | null): void {
    if (value) {
      this.form.setValue(value, { emitEvent: false });
    }
  }

  registerOnChange(fn: (value: ParkingSpaceAddressDto) => void): void {
    this.onChange = fn;
    this.sub = this.form.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
